import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchVisitExternalPhotoTypes = async ({ visitId }) => {
  const token = localStorage.getItem("token");

  const res = await axios.get(`${__API_URL__}/api/photos/visits/${visitId}/external-photo-types/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const selectTypes = (data) => data.external_photo_types;

const useGetVisitExternalPhotoTypes = ({ visitId, enabled = true, select = selectTypes }) => {
  return useQuery({
    queryKey: ["visit_external_photo_types", visitId],
    queryFn: () => fetchVisitExternalPhotoTypes({ visitId }),
    select,
    enabled: enabled && Boolean(visitId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load visit external photo types");
    },
  });
};

export default useGetVisitExternalPhotoTypes;
